// FeedViewCompact.jsx

import React from 'react';

// Components
import FeedView from './FeedView';

const MAX_NODES = 4;

/**
 * FeedViewCompact
 *
 * Compact feed renderer for constrained surfaces (e.g. dashboard cards).
 * Reuses FeedView and limits items to keep cards scannable.
 *
 * @returns {ReactNode} The rendered component.
 */
const FeedViewCompact = React.memo(({
  view,
  typeDef,
  nodes = [],
  language = 'en',
  shareSelection = null,
}) => {

  // ----- RENDER ----- //

  return (
  <FeedView
    view={view}
    typeDef={typeDef}
    nodes={nodes}
    language={language}
    maxNodes={MAX_NODES}
    compact
    shareSelection={shareSelection}
  />
  );
});

// Dev Tools
FeedViewCompact.displayName = 'FeedViewCompact';

export default FeedViewCompact;
